// extracted by mini-css-extract-plugin
module.exports = {"ControlPanel":"ControlPanel_ControlPanel__3O33e"};